import {
  medigiLanding,
  medshortsLanding,
  outsourcingLanding,
} from 'src/app/shared/models/landing';
import { defaultSupplierConfig } from 'src/environments/hydra/configs';
import { hydraSupplierConfigMap } from 'src/environments/hydra/config.map';

const supplierConfig =
  window.location.host in hydraSupplierConfigMap
    ? hydraSupplierConfigMap[window.location.host]
    : defaultSupplierConfig;

const baseURL = 'https://hikma-production-api.medigi.com';

export const environment = {
  production: false,
  env_name: 'hikma',
  domain: 'hikma-production.medigi.com',
  url: 'https://hikma-production.medigi.com',
  api_url_v1: baseURL,
  api_url_v2: baseURL,
  singleton_service_url: 'https://default-production-api.medigi.com',
  medshorts_url: 'https://staging.medshorts.com',
  flower_url: 'http://localhost:8081/misc/flower/dashboard',
  health_url: 'http://localhost:8081/misc/health',
  auth_url: `${baseURL}/auth`,
  auth_url_login: `${baseURL}/auth/login`,
  proxy_url: 'http://localhost:8081/misc/proxy',
  express222Form: 'asdf',
  gatag: undefined,
  clientDomains: {
    outsourcingDomian: 'hikma-production-503b.medigi.com',
    medigiDomain: 'www.hikmadirect.com',
    medshortsDomain: 'hikma-production-medshorts.medigi.com',
    cgtDomain: '',
  },
  availableThemes: {
    'www.hikmadirect.com': medigiLanding,
    'hikma-production-medshorts.medigi.com': medshortsLanding,
    'hikma-production-503b.medigi.com': outsourcingLanding,
  },
  catalogType: {
    'www.hikmadirect.com': 'medigi',
    'hikma-production-medshorts.medigi.com': 'medshorts',
    'hikma-production-503b.medigi.com': '503b',
  },
  customLogoutURL: undefined,
  hydraEnabled: true,
  auth0: {
    clientId: 'oO9UNz0vr501PHplc42JkZ4QonZdOPUp',
    domain: 'hydraprod.us.auth0.com',
    apiIdentifier: 'https://hydraprod.us.auth0.com/api/v2/',
    appMetadata: 'http://hydraprod.com/api/app_metadata',
    userMetadata: 'http://hydraprod.com/api/user_metadata',
    supplierHostMap: {},
  },
  sentry: {
    dsn: 'https://5e36bed6faf54ea9533855f85db421e0@o4506106420330496.ingest.sentry.io/4506107209580544',
  },
  posthog: {
    apiKey: 'phc_jbdhHfqjrBxucSE7TRC07TZ6aNJ1jplImvudvd9oWR9', // TODO: Make this a template variable if needed
    apiHost: 'https://us.i.posthog.com',
    enabled: true,
    autocapture: true,
    capture_pageview: true,
    session_recording: {
      enabled: true,
      maskAllInputs: true,
      maskTextSelector: '.sensitive, .phi, .pii',
    },
  },
  legisym_url: 'https://demo.dev.express222.com/prompt.php',
  supplierConfig: supplierConfig,
};
